import React, { Component, Profiler } from 'react'
import classNames from 'classnames';
import MaterialMenuItem from '@material-ui/core/MenuItem';

import Menu from '@material-ui/core/Menu';
import Divider from '@material-ui/core/Divider';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import { Trade } from '../../models/Trade';
import { DragDropContext, DropResult, DragStart, ResponderProvided, DragUpdate, Droppable } from '../react-beautiful-dnd';
import { Lookahead, PhasePlanStatus, RowGroup } from '../../models/Lookahead';

import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { maxZoom, minZoom, defaultZoom, getZoomAmount } from '../PhasePlan/Zoom.util'

import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import MinusIcon from '@material-ui/icons/Remove';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import MoveToInboxOutlinedIcon from '@material-ui/icons/MoveToInboxOutlined';
import { Column, ColumnType } from '../PhasePlan/Column';
import { RowCountColumn } from '../PhasePlan/RowCountColumn'
import { LookaheadTag } from '../../models/LookaheadTag';
import moment, { Moment } from 'moment'
import { Milestone } from '../../models/Milestone';
import Button from '@material-ui/core/Button';
import LookaheadTagDialogContainer from '../Dialogs/LookaheadTagDialogContainer'
import VarianceLogDialogContainer from '../Dialogs/VarianceLogDialogContainer'
import  AddVarianceDialog from '../Dialogs/AddVarianceDialog'
import TagContextMenu from '../TagContextMenu'
import ColumnContextMenu from '../ColumnContextMenu';
import { unstable_trace as trace } from "scheduler/tracing";
import { SelectableGroup } from '../react-selectable-fast'
import { CardProps } from '../PhasePlan/TagCard';
import HelpIcon from '@material-ui/icons/HelpOutline';
import HelpInfoDialog from '../Dialogs/HelpInfoDialog'

import '../../containers/App.css'
import { batch } from 'react-redux';
import { TradeCard } from '../PhasePlan/TradeCard';
import TradeContextMenu from '../TradeContextMenu';
import ConstraintDialog from '../Dialogs/ConstraintDialogContainer';
import ConstraintLogDialog from '../Dialogs/ConstraintLogDialogContainer'
import EndCommitmentDialog from '../Dialogs/EndCommitmentDialog'
import UploadTaskDialog from '../Dialogs/UploadTasksDialog'
import { TagType, SelectedTag } from '../../models/ TagType';
import { TagChangeInterface, TagsChangesInterface } from '../../actions/phaseplan.actions';
import { homeActions } from '../../actions/home.actions'
import { getPointFromDroppableId, isSelectMultiPressed } from '../../selectors/util.selector';
import { Constraint } from '../../models/Constraint';
import { Point } from '../../modules/ui.reducer';
import GREEN from '@material-ui/core/colors/GREEN';
import RED from '@material-ui/core/colors/RED'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip'
import CommitChooserComponent from '../CommitChooser'
import ScrollContainer from '../IndianaScroll'
import { debounce } from "lodash";
import useDockMouseSensor from '../use-mouse-sensor';
import RightDrawerContainer from '../Drawers/RightDrawerContainer'
import BatchTagDialog from '../Dialogs/BatchTagDialogContainer';
import RowContextMenu from '../RowContextMenu';
import { Typography } from '@material-ui/core';
import RowCountDialog from '../Dialogs/RowCountDialog';
import { Bound, LookaheadNameKey, NewTagType } from '../../selectors/lookahead.selector';
import { DateRow } from '../PhasePlan/DateRow';
import PrintBoardDialog from '../Dialogs/PrintBoardDialog';
import { DragUtilityButtons } from './DragUtilityButtons'

const _ = require('lodash');


function mod(n:number, m:number) {
	return ((n % m) + m) % m;
}

interface Props {
	scrollCheck: (left:number, top:number, width:number, height:number, screenWidth:number, screenHeight: number) => Promise<void>;
	clearUndoCommands: () => void;
	classes: ClassNameMap;
    trades: Record<string, Trade>;
    projectId: string;
    lookaheadNames: LookaheadNameKey[]
    selectedLookaheadId: string;
	hasStartedPhasePlan: boolean;
	selectNewLookahead: (lookaheadKey: string) => Promise<void>;
	changeLookaheadTagColumn: (changes: TagsChangesInterface) => Promise<void>;
	minLookaheadDate: number;
	maxLookaheadDate: number;
	tags: Record<string, LookaheadTag>;
	milestones: Record<string, Milestone>;
	showLookaheadTagDialogValue: (tagId: string | null) => Promise<void>,
	showTradeDialogValue: (tradeId?: string | null) => Promise<void>,
	deleteLookaheadTagColumn: (changes: TagsChangesInterface) => Promise<void>
	unselectAllSelectTags: () => Promise<void>
	selectedTagsSet: Record<string, SelectedTag>
	tagSelected: (tags: Record<string, SelectedTag>) => Promise<void>
	tagsClear: () => Promise<void>
	isSelectMultPressed: boolean
	openHelpDialog: () => void
	columnClear: () => void
	constraints: Record<string, Constraint>;
	showPendingDragUpdates: (tagId:string, newPoint:Point, oldPoint: Point) => void;
	clearPendingDragUpdates: () => void
	copiedTagsCount: number,
	openConstraintDialog: (constraintId?: string) => void,
	openCommitTagDialog: () => void,
	openVarianceLogDialog: () => void,
	lookaheadId: string;
	showConstraintLogDialog: () => void;
	hasCommitment: boolean;
	openEndCommitDialog: () => void;
	_isHistogramOpen: boolean;
	openTaskFilesDialog: () => void;
	isDialogOpen: boolean;
	isLockedDown: boolean;
	lockDownPlan: () => void;
	openDeleteTagDialog: (tags :Record<string, SelectedTag>, type: ColumnType) => Promise<void>;
	milestoneKeys: Set<String>;
	lookaheadOffDays: Set<number>;
	lookaheadName: String;
	rowGroups: Record<string, RowGroup>;
	closedRowGroups: number[];
	groupBounds: Record<number, Bound>;
	openPrintBoardDialog:  () => void;
	isAdmin: boolean;
	userTrades: Set<string>;
	updateZoom: (zoom: number) => void;
	undoTag: () => void;
}

type State = {
	zoomStep: number,
	lookaheadListOpen: any | null
	draggedTag: string | null,
	clientPoint: Point,
	scrollPoint: Point,
	isScrolling: boolean, 
	zoom: number,
	utilityTagsOpen: boolean,
	showColumns: boolean,
	tradeFilter: any | null,
	goToday: boolean
}


class LookaheadScreen extends Component<Props, State> {
	pickerRef = null;
	columns: any;
	container =  React.createRef()
	isTradeDrawerOpen: boolean = false;

	constructor(props: Props) {
		super(props)
		this.mrpColumnRef = React.createRef();
		props.dispatch(homeActions.closeCircularProgressLoading());


			this.state = {
				zoomStep: 11,
				zoom: 100,
				lookaheadListOpen: null,
				draggedTag: null,
				isScrolling: false,
				clientPoint: {
					column: 0,
					row: 0
				},
				scrollPoint: {
					column: 0,
					row: 0
				},
				tradeFilterMenu: null, 
				utilityTagsOpen: false,
				showColumns: false,
				goToday: false
			}

			this.columns = {}
		

	}

	getLookaheadName = () => {
		const { lookaheadName } = this.props

		return lookaheadName
	}

	handleLookaheadListClick = (event: any) => {
        if (!!this.state.lookaheadListOpen) return;
        this.setState({
			lookaheadListOpen: event.currentTarget
      });
	}

	handleLookaheadListClose = () => {
        this.setState({ lookaheadListOpen: null });
	}
	
	handleLookaheadListSelected = (lookaheadKey:string) => {

		return async () => {
			this.props.selectNewLookahead(lookaheadKey)
			this.setState({
				lookaheadListOpen: null
		  });
		}
	}

	handleConstraintLogSelected = async () => {
		this.props.showConstraintLogDialog()
		this.handleLookaheadListClose()
	}

	handleVarianceLogSelected = async () => {
		this.props.showConstraintLogDialog()
		this.handleLookaheadListClose()
	}	

	handlePrintBoardDialog = () => {
		this.props.openPrintBoardDialog()
		this.handleLookaheadListClose()

	}

	renderCommitToWorkBtn = () => {
		const { hasCommitment } = this.props

		if(hasCommitment) return

		const { isAdmin } = this.props
		if(!isAdmin){
			return
		}

		return (
			<MaterialMenuItem onClick={this.showCommitTagsDialog}>
				Commit To Work
			</MaterialMenuItem>
		)
	}

	renderVarianceLogBtn = () => {
		const { hasCommitment } = this.props

		if(!hasCommitment) return

		return (
			<MaterialMenuItem onClick={this.showVarienceLogDialog}>
				Open Variance Log
			</MaterialMenuItem>
		)
	}

	renderEndCommitmentBtn = () => {
		const { hasCommitment } = this.props

		if(!hasCommitment) return

		const { isAdmin } = this.props
		if(!isAdmin){
			return
		}

		return (
			<MaterialMenuItem onClick={this.showEndCommitDialog}>
				End Commitment
			</MaterialMenuItem>
		)
	}

	renderImportTaskBtn = () => {
		const { isAdmin } = this.props
		if(!isAdmin){
			return
		}
		return (
			<MaterialMenuItem onClick={this.showTaskFilesDialog}>
				Import Tags
			</MaterialMenuItem>
			
		)
	}

	

	renderLookaheadMenu = () => {
		const { selectedLookaheadId, projectId, lookaheadNames, lookaheadName } = this.props

		const lookaheadId = selectedLookaheadId
		
		return( 
			<Menu
				id="lookahead-menu"
				anchorEl={this.state.lookaheadListOpen}
				open={Boolean(this.state.lookaheadListOpen)}
				onClose={this.handleLookaheadListClose}
        	>
				{lookaheadNames.map((namekey) => {
					return (
						<MaterialMenuItem onClick={this.handleLookaheadListSelected(namekey.uid)} >
							{namekey.name} 
						</MaterialMenuItem>
					)
				})}
			<Divider />
				<MaterialMenuItem onClick={this.props.showConstraintLogDialog}>
					Open Constraint Log
				</MaterialMenuItem>
				{this.renderCommitToWorkBtn()}
				{this.renderVarianceLogBtn()}
				{this.renderEndCommitmentBtn()}
				{this.renderImportTaskBtn()}
				<MaterialMenuItem onClick={this.handlePrintBoardDialog}>
					Email Printable Schedule
				</MaterialMenuItem>
				{/*<a style={{textDecoration: 'none'}} download={`${lookaheadName}.zip`} href={`https://cloud-schedule-parser.herokuapp.com/project/${projectId}/makeReadyPlan/${lookaheadId}/getXERFile/${encodeURIComponent(lookaheadName)}.zip`}>
					<MaterialMenuItem >
						Download XER
					</MaterialMenuItem>
				</a>
				*/}

			</Menu>
		)
	}

	renderHelpInfoButton = () => {
		return (
			<IconButton onClick={this.props.openHelpDialog}>
				<HelpIcon style={{color: '#fff'}} />
			</IconButton>
		)
	}

	renderMultiSelectStatusColor = () => {
		const { isSelectMultPressed } = this.props

		if(isSelectMultPressed) {
			return GREEN[500]
		}

		return	
	}

	renderCopyStatusColor = () => {
		const { copiedTagsCount } = this.props
		if(copiedTagsCount > 0) {
			return GREEN[500]
		}

		return	
	}

	renderCommitmentStatusColor = () => {
		const { hasCommitment } = this.props
		if(hasCommitment) {
			return GREEN[500]
		}

		return	
	}

	renderLockDownStatusColor = () => {
		const { isLockedDown } = this.props
		if(isLockedDown) {
			return RED[500]
		}

		return
	}

	renderMultiSelectStatusText = () => {
		const { isSelectMultPressed } = this.props
		if(isSelectMultPressed) {
			return "Multi Select On"
		}

		return	"Multi Select Off"
	}

	renderCopyStatusText = () => {
		const { copiedTagsCount } = this.props
		if(copiedTagsCount > 0 ) {
			return `Copying ${copiedTagsCount} Stickies Note`
		}
		return 'Not Copying'
	}

	renderCommitmentText = () => {
		const { hasCommitment } = this.props

		if(hasCommitment) {
			return "Active Commitment"
		}

		return "No Active Commitment"
	}

	renderLockDownText = () => {
		const { isLockedDown } = this.props

		if(isLockedDown) {
			return "Locked"
		}

		return "Unlocked"
	}

	renderUndoButton = () => {
		return (
			<MuiThemeProvider theme={theme =>
				createMuiTheme({
					...theme,
					overrides: {
						
					}
				})
			}
		>
			<div style ={{marginLeft: 16}}>
				<Chip onClick={this.props.undoTag}color="primary" label={"Undo"} />
			</div>
		</MuiThemeProvider>
		)
	}


	renderMultiSelectStatus = () => {

		return (
				<MuiThemeProvider theme={theme =>
					createMuiTheme({
						...theme,
						overrides: {
							MuiChip: {
								colorPrimary: {
									backgroundColor: this.renderMultiSelectStatusColor()
								}
							}
						}
					})
				}
			>
				<div style ={{marginLeft: 16}}>
					<Chip color="primary" label={this.renderMultiSelectStatusText()} />
				</div>
			</MuiThemeProvider>
		)
	}

	renderCopyStatus = () => {
		return (
			<MuiThemeProvider theme={theme =>
					createMuiTheme({
						...theme,
						overrides: {
							MuiChip: {
								colorPrimary: {
									backgroundColor: this.renderCopyStatusColor()
								}
							}
						}
					})
				}
			>
				<div style ={{marginLeft: 16}}>
					<Chip color="primary" label={this.renderCopyStatusText()} />
				</div>
			</MuiThemeProvider>
		)
	}

	renderCommitmentStatus = () => {
		return (
			<MuiThemeProvider theme={theme =>
					createMuiTheme({
						...theme,
						overrides: {
							MuiChip: {
								colorPrimary: {
									backgroundColor: this.renderCommitmentStatusColor()
								}
							}
						}
					})
				}
			>
				<div style ={{marginLeft: 16}}>
					<Chip color="primary" label={this.renderCommitmentText()} />
				</div>
			</MuiThemeProvider>
		)
	}

	gotoToday = () => {
		const today = moment().format('l')
		this.scrollToDate(today, 'center')
	}
	

	toggleLockDown = () => {
		const { lockDownPlan } = this.props
		lockDownPlan()
	}

	renderLockDownStatus = () => {
		return (
			<MuiThemeProvider theme={theme =>
					createMuiTheme({
						...theme,
						overrides: {
							MuiChip: {
								colorPrimary: {
									backgroundColor: this.renderLockDownStatusColor()
								}
							}
						}
					})
				}
			>
				<div style ={{marginLeft: 16}}>
					<Chip onClick={this.toggleLockDown}color="primary" label={this.renderLockDownText()} />
				</div>
			</MuiThemeProvider>
		)
	}

	renderGoToday = () => {
		return (
			<MuiThemeProvider theme={theme =>
					createMuiTheme({
						...theme,
						overrides: {
							MuiChip: {
								colorPrimary: {
									backgroundColor: GREEN[500]
								}
							}
						}
					})
				}
			>
				<div style ={{marginLeft: 16}}>
					<Chip onClick={this.gotoToday}color="primary" label={"Go To Today"} />
				</div>
			</MuiThemeProvider>
		)
	}


	renderTopBar = () => {
		const { classes, _isHistogramOpen } = this.props
		const { lookaheadNames } = this.props

		const keys = lookaheadNames

		if(keys.length <= 0) {
			return
		}

		return (
			<div className={classNames(classes.PhaseScreenTopBar)}>
				{this.renderLookaheadMenu()}
				<p className={classNames(classes.PhaseScreenTitle)}>
                    
					Plan:
				</p>
				<button onClick={this.handleLookaheadListClick} style={{display: 'flex', marginLeft: 16}} className={classes.TransparentButton}>
					<p className={classNames(classes.PhaseScreenTitle)}>
						{this.getLookaheadName()}
					</p>
					<ArrowDropDownIcon style={{color: '#fff'}} />
				</button>

				{this.renderHelpInfoButton()}
				{this.renderMultiSelectStatus()}
				{this.renderCopyStatus()}
				{this.renderCommitmentStatus()}
				{this.renderLockDownStatus()}
				{this.renderGoToday()}
				{this.renderButtons()}
		</div>
		)
	}
	
	getTagTypeFromId = (tagId:string) => {
		
		if(!!this.props.constraints && !!this.props.constraints[tagId] ) {
			return TagType.Constraint
		}

		return TagType.Lookahead
	}

	onDragEnd = async (result: DropResult) => {

		this.props.clearUndoCommands()
		
		const destination = result.destination;
		const source = result.source

		const { draggedTag } = this.state
		const { 
			deleteLookaheadTagColumn,
			changeLookaheadTagColumn, 
			selectedTagsSet,
			columnClear, 
			clearPendingDragUpdates, 
			tags,
			milestoneKeys 
		} = this.props
		// nothing to do


		if (!destination || result.reason === 'CANCEL' || draggedTag === null) {
			clearPendingDragUpdates()

			this.state.draggedTag = null
			this.state.utilityTagsOpen = false
			return;
		}

		//Get the dragged tag column and index
		const draggedNewPoint = getPointFromDroppableId(destination.droppableId)
		const draggedOldPoint = getPointFromDroppableId(source.droppableId)

		const newColumnId = draggedNewPoint.column
		const newIndexId = draggedNewPoint.row
	
		const oldColumnId = draggedOldPoint.column
		const oldIndexId = draggedOldPoint.row

		//Calculate the column offset and index offset new - old = offset

		const newColumnMoment = moment(newColumnId)
		const oldColumnMoment = moment(oldColumnId)

		const offsetColumn = newColumnMoment.diff(oldColumnMoment, 'days')
		const offsetIndex = newIndexId - oldIndexId

		// Get the select tags
		const selectedTags =  {...selectedTagsSet}

		// adjust their column and index by adding offset old + offset = new

		const changes = Object.keys(selectedTags).filter((tagId:string) => draggedTag !== tagId).reduce((tagMap, tagId) => {
			
			const tag = selectedTags[tagId]
			let newColumn = moment(tag.position.column).add(offsetColumn, 'days').format('l')
			const newRow = parseInt(tag.position.row, 10) + parseInt(offsetIndex, 10)

			tagMap[tagId] = {
				newColumn: newColumn,
				tagCardType: tag.tagCardType,
				newIndex: newRow
			}
			return tagMap
		},{} as Record<string, TagChangeInterface>)


		// adds the draggedTag to changes
		if(destination.droppableId !== '-1' || destination.droppableId !== '-2') {
			const tagType = this.getTagTypeFromId(draggedTag)
			changes[draggedTag] = {
				newColumn: moment(newColumnId).format('l'),
				tagCardType: tagType,
				newIndex: newIndexId,
			} as TagChangeInterface

		} else {
			const tagType = this.getTagTypeFromId(draggedTag)

			changes[draggedTag] = {
				newColumn: -1,
				tagCardType: tagType,
				newIndex: -1
			} as TagChangeInterface
		}
		
		if(destination.droppableId === '-1'  || destination.droppableId === '-2') {
			batch(() => {
				columnClear()
				deleteLookaheadTagColumn(changes)
				clearPendingDragUpdates()
			})
		} else if( destination.droppableId === 'delete') {
			this.handleCircularDelete()
		} else if ( destination.droppableId === 'move' ) {
			this.handleCircularDrawerMove()
		} else {
			batch(() => {
				columnClear()
				changeLookaheadTagColumn(changes)
				clearPendingDragUpdates()
			})
		}
		
		this.setState({
			draggedTag: null,
			utilityTagsOpen: false,
		})	
	}

	onDragUpdate = async (update: DragUpdate) => {
		const { draggedTag } = this.state
		const { clearPendingDragUpdates, showPendingDragUpdates } = this.props

		if(!draggedTag) {
			return 
		}
		if(!update.destination) {
			clearPendingDragUpdates()
		}


		if(!!update.destination) {
			const newPoint:Point = getPointFromDroppableId(update.destination?.droppableId)
			const oldPoint:Point = getPointFromDroppableId(update.source.droppableId)

			showPendingDragUpdates(update.draggableId, Object.freeze(newPoint), Object.freeze(oldPoint))
		}
	}

	onDragStart = (start: DragStart) => {
		const { columnClear } = this.props
		const id= start.draggableId;
		const selected = !!this.props.selectedTagsSet[id];

		columnClear()

		// if dragging an item that is not selected - unselect all items
		if (!selected) {
		  this.props.unselectAllSelectTags();
		}

		this.state.draggedTag = start.draggableId
	}

	onBeforeDragStart = async (start: DragStart) => {
		if(!this.state.utilityTagsOpen) {
			this.setState({
				utilityTagsOpen: true
			})
		}
	}

	renderTradeContractorGrid(trade: Trade) {
		return( 
			<TradeCard  
				isDisabled={false}	
				trade={trade} 
			/>
		)
	}

	onTradeClicked(trade: Trade) {
		return async () => {
			this.props.showTradeDialogValue(trade.uid)
		}
	}

	onWheel = (event:any) => {
		const { isDialogOpen } = this.props


		if( isDialogOpen || this.isTradeDrawerOpen) {
			return
		}
		event.preventDefault()
		if(event.deltaY > 4) {
			this.onZoomOut()

		}
		if(event.deltaY < -4) {
			this.onZoomIn()
		}
	}

	getFowardRef(currentDate: Moment) {
		return (ref: React.ReactInstance) => {
			if(!this.columns[currentDate.format('l')]) {
				this.columns[currentDate.format('l')] = ref
			}
		}
	}

	renderLocationGridColumn = () => {
		const { 
			groupBounds, 
			classes, 
			trades, 
			minLookaheadDate, 
			maxLookaheadDate, 
			lookaheadOffDays, 
			closedRowGroups, 
			rowGroups,
			isAdmin,
			userTrades
		} = this.props
		const { zoomStep, zoom } = this.state

		if(minLookaheadDate == null || maxLookaheadDate == null) {
			return
		}


		const offDays =  lookaheadOffDays

		const startDate = moment(minLookaheadDate, 'l').startOf('day')
		const endDate = moment(maxLookaheadDate, 'l').startOf('day')

		const daysBetween = endDate.diff(startDate, 'days')

		const columns =  Array(daysBetween).fill(1).map((_, columnIndex) => {
			const currentDate = startDate.clone().add(columnIndex, 'day')
			
			return (
				<Column
					show={this.state.showColumns}
					key={currentDate.valueOf()}
					rowGroups={rowGroups}
					closedRowGroups={closedRowGroups}
					isDisabled={false}
					isOffDay={offDays.has(currentDate.day())}
					type={ColumnType.Lookahead}
					zoomStep={zoomStep}
					column={currentDate.valueOf()}
					groupBounds={groupBounds}
					isAdmin={isAdmin}
					userTrades={userTrades} />
			)
		})


		this.setState({goToday: true})

		return columns
	}

	renderTagGrid() {
		const { classes  } = this.props

		return (

			<div   className={classes.PhasePlanLocationGrid}>
				{this.renderLocationGridColumn()}
			</div>
		)
	}

	renderLocationRow() {
		const { classes } = this.props

		return (
			<div   className={classes.PhasePlanLocationGrid}>
				{this.renderLocationGridColumn()}
			</div>
		)
	}

	getSelectClassName() {
		const { isSelectMultPressed } = this.props

		return !isSelectMultPressed ? 'blahblah' : 'selectable-selectbox'
	}

	onSelectClear = async () => {
		const { tagsClear, isSelectMultPressed  } = this.props

		if(isSelectMultPressed){
			tagsClear()
		}
	}

	canAccessTag = (tradeId: string) => {
        const { userTrades, isAdmin } = this.props

        let canMove = false;

        if (isAdmin) {
            canMove = true;
        }

        if (!!userTrades && !!tradeId && !isAdmin) {
            canMove = userTrades.has(tradeId);
        }
        return canMove;
    }

	onSelectionFinish = async (e: any[]) => {
		const { tagSelected, isSelectMultPressed, clearPendingDragUpdates, selectedTagsSet  } = this.props

		let allGroupedSelectedTags:Record<string, SelectedTag> = e
		.filter((node: any) => !!node.props.uid)
		.filter((node: any) => this.canAccessTag(node.props.tradeId))
		.map((node: any) =>{
			const cardProps: CardProps = node.props
			return {
				tagId: cardProps.uid,
				tagCardType: cardProps.tagCardType,
				position: {
					column: moment(cardProps.tagDate,'l').valueOf(),
					row: cardProps.index
				}
			}
		}).reduce((obj, tag) => {
			obj[tag.tagId] = Object.freeze(tag)
			return obj
		}, {} as Record<string, SelectedTag>)

		allGroupedSelectedTags = {...allGroupedSelectedTags, ...selectedTagsSet}

		if(isSelectMultPressed) {
			batch(() => {
				clearPendingDragUpdates()
				tagSelected(allGroupedSelectedTags)
			})
		}
	}


	renderRow = () => {
		const { classes, isSelectMultPressed  } = this.props

		return (
			
				<div className={classes.PhasePlanLocationListContainer}>
					{this.renderLocationRow()}
				</div>

		)
	}

	onFullScreenChanged = (isFullScreen: boolean) => {

		//this.isDrawerFullScreen = isFullScreen
	}

	onTradeOpen = (isTradeDrawerOpen: boolean) => {
		this.isTradeDrawerOpen = isTradeDrawerOpen

	}

	screenWidth = () => {
		return window.innerWidth 
			|| document.documentElement.clientWidth 
			|| document.body.clientWidth 
			|| 0;
	 }
	 
	screenHeight = () => {
		return window.innerHeight 
			|| document.documentElement.clientHeight 
			|| document.body.clientHeight 
			|| 0;
	 }

	onScrollListener = async (left:number, top:number, width:number, height:number) => {
		const { scrollCheck } = this.props
		scrollCheck(left, top, width, height,this.screenWidth(), this.screenHeight())
	}

	renderMain = () => {
		const { classes, minLookaheadDate, maxLookaheadDate, trades, isSelectMultPressed } = this.props
		const {  zoomStep } = this.state

		const { draggedTag, zoom, utilityTagsOpen } = this.state
		
		const { lookaheadNames, rowGroups, closedRowGroups, userTrades, isAdmin,  } = this.props

		const keys = lookaheadNames

		if(keys.length <= 0) {
			return
		}

		const style = {
			transform: `scale(${zoom/100})`,
			'-moz-transform': `scale(${zoom/100})`,
			'-webkit-transform': `scale(${zoom/100})`,
			'transform-origin': 'top left',
		}
		if(this.mrpColumnRef.current) {
			style.height = this.mrpColumnRef.current.clientHeight / (zoom/100)
			if(zoom < defaultZoom) style.width = this.mrpColumnRef.current.clientWidth / (zoom/100)
		}

		return (
			<React.Fragment>
				<div className={classes.PhasePlanMain}>
						<RowCountColumn 
							rowGroups={rowGroups}
							closedRowGroups={closedRowGroups}
							zoomStep={zoomStep} 
							zoom={zoom}
							columnsWrapRef={this.mrpColumnRef}
						/>
							<div className={classes.MRPColumn} ref={this.mrpColumnRef}>
								{

								}
								
									<ScrollContainer
										onScroll={this.onScrollListener}
										zoom={zoom}
										ignoreElements={".TagCard"}
										ref={this.container}
										className={classNames(classes.PhaseContainer, "scroll-container")}
										style={style}
									>
										<SelectableGroup
											selectboxClassName={this.getSelectClassName()}
											delta={(zoom/100)}
											fixedPosition={true}
											enableDeselect={true}
											allowCtrlClick={true}
											allowMetaClick={true}
											allowShiftClick={true}
											resetOnStart={false}
											tolerance={4}
											disabled={!isSelectMultPressed}
											scrollContainer=".scroll-container"
											onSelectionClear={this.onSelectClear}
											onSelectionFinish={this.onSelectionFinish}
										>
											<div ref={this.lookaheadBoardParentElem } className={classes.PhasePlanTagMain} >

												{this.renderRow()}
											</div>
										</SelectableGroup>

									</ScrollContainer>
							</div>

						<div className={classes.ZoomContainer} style={{ minWidth: '150px', position: 'absolute', bottom: "5vh", right: '5vw'}} >  
							<IconButton className={classes.ZoomButtons} onClick={this._onZoomIn} >
								<AddIcon className={classes.ZoomIcons} />
							</IconButton>
							<IconButton className={classes.ZoomButtons} onClick={this._onZoomOut}  >
								<MinusIcon className={classes.ZoomIcons} />
							</IconButton>
						</div>
						<DragUtilityButtons utilityTagsOpen={utilityTagsOpen} />	
						<RightDrawerContainer
							userTrades={userTrades}
							isAdmin={isAdmin}
							draggedTag={draggedTag}
							classes={classes}
							chartType="lookahead"
							onFullScreenChanged={this.onFullScreenChanged}
							onTradeOpen={this.onTradeOpen}
						/>
					</div>
			</React.Fragment>
		)
	}

	handleCircularDelete = () => {
		const { openDeleteTagDialog, selectedTagsSet, tags} = this.props; 
		const { draggedTag } = this.state; 

		if(!draggedTag && !selectedTagsSet) {
			return
		}

		const tagType = this.getTagTypeFromId(draggedTag)
		const changes = {...selectedTagsSet}
		changes[draggedTag] = {
			tagCardType: tagType,
			tagType: tagType
		}

		openDeleteTagDialog(changes, ColumnType.Lookahead)
	}

	handleCircularDrawerMove = () => {
		const { selectedTagsSet, deleteLookaheadTagColumn, tags } = this.props; 
		const { draggedTag } = this.state; 
		const changes = {} as Record<string, TagChangeInterface>; 
		if(!draggedTag && !selectedTagsSet) {
			return
		}

		const tagType = this.getTagTypeFromId(draggedTag)

		changes[draggedTag] = {
			tagCardType: tagType,
			tagType: tagType
		}


		for (let tag in selectedTagsSet) {
			changes[tag] = {
				tagCardType: selectedTagsSet[tag].tagCardType,
				tagType: selectedTagsSet[tag].tagType,
				position: {
					column: selectedTagsSet[tag].position.column,
					row: selectedTagsSet[tag].position.row,
				}
			}
		}
		deleteLookaheadTagColumn(changes)
	}

	showTagDialog = async () => {
		this.props.showLookaheadTagDialogValue(null)
	}

	showTradeDialog = async () => {
		this.props.showTradeDialogValue(null)
	}

	showConstraintDialog = async () => {
		this.props.openConstraintDialog()
	}

	showTaskFilesDialog = async () => {
		this.props.openTaskFilesDialog()
		this.handleLookaheadListClose()
	}

	showVarienceLogDialog = () => {
		this.props.openVarianceLogDialog()
		this.handleLookaheadListClose()
	}

	showCommitTagsDialog = () => {
		this.props.openCommitTagDialog()
		this.handleLookaheadListClose()
	}

	showEndCommitDialog = () => {

		this.props.openEndCommitDialog()
		this.handleLookaheadListClose()
	}

	renderButtons = () => {
		const { classes, tradeFilter } = this.props

		return (
			<React.Fragment>
					<Button className={classes.BackLogButton} size="small" color="default"  variant="contained" onClick={this.handleFilterButtonClick}>
								<Typography variant="body1">Filtering By: { tradeFilter ? tradeFilter.name : ''}</Typography>
							<ArrowDropDownIcon style={{color: '#fff'}} />
					</Button>
					{this.makeReadyPlanFilterMenu()}

			</React.Fragment>
		)	
	}

	handleFilterButtonClick = (event) => {
		if (!!this.state.tradeFilterMenu) return;
		this.setState({
			tradeFilterMenu: event.currentTarget
		});
	}

	handleTradeFilterMenuClose = () => {
		this.setState({ tradeFilterMenu: null });
	}

	handleTradeFilter = (trade) => {
		this.props.filterTagsByTrade(trade)
	}

	makeReadyPlanFilterMenu  = () => {
		const { trades, tradeFilter } = this.props;
		return (
			<Menu
				anchorEl={this.state.tradeFilterMenu}
				open={!!this.state.tradeFilterMenu}
				onClose={this.handleTradeFilterMenuClose}
			>
					<MaterialMenuItem onClick={() => this.handleTradeFilter(null)}> Reset Filters</MaterialMenuItem>
					<Divider />
				{
					Object.values(!!trades ? trades : {}).map(trade => {
						return (
							<MaterialMenuItem key={trade.uid} selected={ tradeFilter ? trade.uid === tradeFilter.uid : false } onClick={() => this.handleTradeFilter(trade)}> {trade.name} </MaterialMenuItem>
						)
					})
				}
			</Menu>
		)
	}

	scrollToDate = (date:string, position:string) => {
		if(this.container.current){

			const startDate = moment(this.props.minLookaheadDate, 'l').startOf('day')
			const scrollDate = moment(date, 'l').startOf('day')
			const daysBetween = scrollDate.diff(startDate, 'days')
			const width = getZoomAmount(this.state.zoomStep)

			let scrollX = daysBetween*width-24


			if(position === 'center') {
				const zoomRatio = this.state.zoom/100
				const containerRect = this.container.current.getBoundingClientRect()
				const containerWidth = zoomRatio < 1 ? containerRect.width : this.container.current.getValue('offsetWidth')
				const offset = (containerWidth/zoomRatio)/2 - containerRect.left
				scrollX = scrollX - offset
			}

			
			this.container.current.scrollTo(scrollX, 0)
			this.container.current.scrollTo(scrollX, 0)
			this.container.current.scrollTo(scrollX, 0)

		}
	}

	componentDidMount() {
		window.addEventListener('wheel', this.onWheel, {passive: false})
		this.setState({ showColumns: true })

	}


	componentDidUpdate(prevProps:Props, prevState:State) {

			const ref = this.columns[moment().format('l')]

			if(!!ref && !!this.container.current){

				const scrollElement = this.container.current.getElement() as HTMLElement

				//scrollElement.scroll(ref.offsetLeft, 0)
			}
		

		if(prevProps.selectedLookaheadId !== this.props.selectedLookaheadId) {
			const ref = this.columns[moment().format('l')]

			if(!!ref && !!this.container.current){

				const scrollElement = this.container.current.getElement() as HTMLElement

				//scrollElement.scroll(ref.offsetLeft, 0)
			}

		}

		if(prevState.goToday == false && this.state.goToday == true) {
			
			const today = moment().format('l')
			this.scrollToDate(today, 'center')
			this.setState({ showColumns: true })

		}
	}

	componentWillUnmount() {
		window.removeEventListener('wheel', this.onWheel)
	}

	shouldComponentUpdate(nextProps :Props, nextState: State) {
		if(this.props.tradeFilter != nextProps.tradeFilter) {
			return true
		}
		if(this.state.tradeFilterMenu != nextState.tradeFilterMenu) {
			return true
		}

		if(!_.isEqual(this.props.maxLookaheadDate, nextProps.maxLookaheadDate)) {
			return true
		}

		if(!_.isEqual(this.props.minLookaheadDate, nextProps.minLookaheadDate)) {
			return true
		}

		if(this.state.zoom !== nextState.zoom) {
			return true
		}

		if(this.state.lookaheadListOpen !== nextState.lookaheadListOpen) {
			return true
		}

		if(!_.isEqual(this.props.milestones, nextProps.milestones)) {
			return true
		}

		if(!_.isEqual(this.props.isSelectMultPressed, nextProps.isSelectMultPressed)) {
			return true
		}

		if(!_.isEqual(this.props.tags, nextProps.tags)) {
			return true
		}

		if(!_.isEqual(this.props.constraints, nextProps.constraints)) {
			return true
		}

		if(!_.isEqual(this.props.trades, nextProps.trades)) {

			return true
		}

		if(this.props.copiedTagsCount !== nextProps.copiedTagsCount) {
			return true
		}

		if(this.props.hasCommitment !== nextProps.hasCommitment) {
			return true
		}

		

		if(this.state.utilityTagsOpen != nextState.utilityTagsOpen) {
			return true
		}

		if(!_.isEqual(this.props.rowGroups, nextProps.rowGroups)) {
			return true
		}

		if(!_.isEqual(this.props.closedRowGroups, nextProps.closedRowGroups)) {
			return true
		}

		if(this.props.selectedLookaheadId != nextProps.selectedLookaheadId) {
			return true
		}

		if(this.state.showColumns != nextState.showColumns) {
			return true
		}

		
		return false
	}

	_onZoomIn = () => {
		const { updateZoom } = this.props


		let newZoom = this.state.zoom + 10

		if(  newZoom >= maxZoom) {
			newZoom = maxZoom 
		}

		this.setState({
			zoom: newZoom 
		})

		updateZoom(newZoom)


		window.dispatchEvent(new CustomEvent('resize'))
	}

	onZoomIn = debounce(this._onZoomIn, 100)

	_onZoomOut = () => {
		const { updateZoom } = this.props


		

		let newZoom = this.state.zoom - 10

		if(newZoom <= minZoom) {
			newZoom = minZoom
		}

		this.setState({
			zoom: newZoom 
		})

		updateZoom(newZoom)
		
		window.dispatchEvent(new CustomEvent('resize'))
	}

	onZoomOut = debounce(this._onZoomOut, 100)



	render() {
		const { classes, minLookaheadDate, maxLookaheadDate } = this.props
		const { zoom, zoomStep } = this.state
		return (
			<React.Fragment>
					<div id="draggable"></div>

					<ColumnContextMenu type={ColumnType.Lookahead} />
					<TagContextMenu type={ColumnType.Lookahead} />
					<RowContextMenu type={ColumnType.Lookahead} />

					<LookaheadTagDialogContainer />
					<TradeContextMenu />
					<ConstraintDialog type={ColumnType.Lookahead} />
					<ConstraintLogDialog />
					<HelpInfoDialog />
					<CommitChooserComponent />
					<PrintBoardDialog />
					<AddVarianceDialog />
					<VarianceLogDialogContainer />
					<EndCommitmentDialog />
					<UploadTaskDialog />
					<BatchTagDialog />
					<RowCountDialog />


					<DragDropContext
						sensors={[useDockMouseSensor]}
						onBeforeDragStart={this.onBeforeDragStart}
						onDragStart={this.onDragStart}
						onDragEnd={this.onDragEnd}
						onDragUpdate={this.onDragUpdate}
					>
						<div className={classNames(classes.PhaseContainer)}>

							{this.renderTopBar()}

							{this.renderMain()}

						</div>
					</DragDropContext>
			</React.Fragment>
		)
	}
}

export default LookaheadScreen;


// WEBPACK FOOTER //
// ./src/components/Lookahead/LookaheadScreen.tsx